const GuardMonitoringDashboard = () => {
    return (
        <div>
            <h1>Guard Monitoring Dashboard</h1>
        </div>
    );
};

export default GuardMonitoringDashboard;